/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Merge_ButtonInputs */

const en_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Group`)
};

const fr_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner le groupe`)
};

const de_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionsgruppe`)
};

const it_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci gruppo`)
};

const ru_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа слияний`)
};

const es_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar grupo`)
};

const zh_cn2_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并集团`)
};

const ja_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを結合`)
};

const hi_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय समूह`)
};

const pt_pt2_merge_event_group_merge_button = /** @type {(inputs: Merge_Event_Group_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Group" |
*
* @param {Merge_Event_Group_Merge_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_merge_button = /** @type {((inputs?: Merge_Event_Group_Merge_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Merge_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_merge_button(inputs)
	if (locale === "de") return de_merge_event_group_merge_button(inputs)
	if (locale === "it") return it_merge_event_group_merge_button(inputs)
	if (locale === "ru") return ru_merge_event_group_merge_button(inputs)
	if (locale === "es") return es_merge_event_group_merge_button(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_merge_button(inputs)
	if (locale === "ja") return ja_merge_event_group_merge_button(inputs)
	if (locale === "hi") return hi_merge_event_group_merge_button(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_merge_button(inputs)
	return en_merge_event_group_merge_button(inputs)
});